import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchDashboardDetailsAction } from "actions/dashboard-actions";
import { trackPageAction } from "actions/shared/tracking-actions";
import { startTourAction, endTourAction } from "actions/app-actions";
import { Dashboard } from "components/dashboard/dashboard";
import { Loading } from "components/common/loading";

class DashboardPage extends React.Component {
  componentWillMount() {
    this.props.init(this.props.accountId);
    this.props.trackPage();
  }

  render() {
    if (this.props.isLoading) {
      return <Loading />;
    }
    return <Dashboard { ...this.props } />;
  }
}

DashboardPage.propTypes = {
  accountId: PropTypes.string.isRequired,
  init: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  trackPage: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  documentCount: state.dashboard.documentCount,
  documentLimit: state.dashboard.documentLimit,
  envelopeCount: state.dashboard.envelopeCount,
  envelopeLimit: state.dashboard.envelopeLimit,
  isLoading: state.dashboard.isLoading,
  name: state.app.user.firstName,
  pendingDocumentCount: state.dashboard.pendingDocumentCount,
  totalCount: state.dashboard.totalCount,
  totalSumFiltered: state.dashboard.totalSumFiltered,
  vendorsCount: state.vendors.vendors.length
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId) => dispatch(fetchDashboardDetailsAction(accountId)),
  trackPage: () => dispatch(trackPageAction("Dashboard page")),
  onEndTour: () => dispatch(endTourAction()),
  onStartTour: (tour) => dispatch(startTourAction(tour))
});

export const DashboardContainer = connect(mapStateToProps, mapDispatchToProps)(DashboardPage);



// WEBPACK FOOTER //
// ./src/js/containers/dashboard-container.jsx